import React from 'react';
import { X } from 'lucide-react';
import { cn } from './ui';

const SIZE_CLASS = {
  sm: 'max-w-[400px]',
  md: 'max-w-[520px]',
  lg: 'max-w-[640px]',
  xl: 'max-w-[980px]',
  full: 'max-w-[1240px]',
};

const Modal = ({ title, onClose, size = 'md', children, className = '' }) => (
  <div
    className="fixed inset-0 z-[1000] flex items-center justify-center overflow-y-auto bg-[#07140E]/55 p-3 backdrop-blur-[8px] sm:p-6"
    onClick={onClose}
  >
    <section
      className={cn(
        'my-auto max-h-[calc(100dvh-1.5rem)] w-full overflow-y-auto rounded-[22px] bg-white shadow-[0_32px_80px_rgba(7,15,11,0.24)] ring-1 ring-white/70 sm:max-h-[90vh]',
        SIZE_CLASS[size] || SIZE_CLASS.md,
        className
      )}
      onClick={(event) => event.stopPropagation()}
      role="dialog"
      aria-modal="true"
      aria-label={title || 'Dialog'}
    >
      {title && (
        <header className="sticky top-0 z-10 flex items-center justify-between gap-4 bg-white/95 px-5 pb-3 pt-5 backdrop-blur-xl sm:px-8 sm:pb-4 sm:pt-6">
          <h2 className="m-0 min-w-0 break-words font-nunito text-xl font-black tracking-[-0.02em] text-giggs-ink sm:text-[22px]">{title}</h2>
          <button
            type="button"
            className="inline-flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-xl border-0 bg-slate-100 p-0 text-giggs-muted transition-all duration-200 hover:rotate-3 hover:bg-red-50 hover:text-red-600 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-red-100"
            onClick={onClose}
            aria-label="Close"
          >
            <X size={19} />
          </button>
        </header>
      )}
      {children}
    </section>
  </div>
);

export default Modal;
